import React from "react";
import {
  MOTION,
  getAnimationDelayStyle,
  useShareDockedMotion,
} from "../lib/animations";
import styles from "./ShareThisArticle.module.scss";

export default function ShareThisArticle({
  title = "Share this article:",
  socials = [],
  onShare,
  className = "",
  layout = "auto",
}) {
  const {
    rootRef,
    isDocked,
    containerAnimationClassName,
    linkAnimationClassName,
  } = useShareDockedMotion(layout);

  return (
    <div
      ref={rootRef}
      data-motion={MOTION.shareContainer}
      className={`${styles.metaShare} ${
        isDocked ? styles.verticalShare : styles.horizontalShare
      } ${containerAnimationClassName} ${className}`.trim()}
      aria-label={title || "Share this article"}
    >
      {title ? <p>{title}</p> : null}
      {socials.map((social, index) => {
        const base = social.iconClass || "";
        const iconKey = `icon${base.charAt(0).toUpperCase()}${base.slice(1)}`;
        const iconClass = styles[iconKey] || "";
        return (
          <a
            key={social.platform}
            href={social.url}
            onClick={onShare ? onShare(social.platform) : undefined}
            aria-label={social.label}
            data-motion={MOTION.shareLink}
            className={linkAnimationClassName}
            style={getAnimationDelayStyle((index + 1) * 0.05)}
          >
            <span className={`${styles.icon} ${iconClass}`.trim()} />
          </a>
        );
      })}
    </div>
  );
}
